// Mock data for Caribou Studio landing page

export const services = [
  {
    id: 1,
    title: "Films",
    description: "From traditional shoot-based productions to cutting-edge AI-generated content, we bring stories to life across every format. Whether it's cinematic brand films, AI-powered animations, immersive documentaries, or scroll-stopping reels, we craft visual narratives that captivate and inspire.",
    image: "https://images.unsplash.com/photo-1610845688109-23f080d7218b"
  },
  {
    id: 2,
    title: "Digital Content",
    description: "From social media campaigns and topical content to influencer collaborations and trending reel series, we help you elevate your digital presence. Our team creates content that doesn't just get noticed—it sparks conversations, builds communities, and drives real engagement.",
    image: "https://images.unsplash.com/photo-1610846136776-8bcdff7f7ef5"
  },
  {
    id: 3,
    title: "Creative Consultancy",
    description: "Get professional admen and women to brainstorm ideas with you. Whether you're a brand or a content creator, consult with us on brand positioning, campaign planning, crisis management, or creative strategy. We bring years of advertising expertise to help you navigate the creative landscape with confidence.",
    image: "https://images.unsplash.com/photo-1718073398740-9d3484bd6340"
  },
  {
    id: 4,
    title: "Experimental",
    description: "We're suckers for great ideas! If you have a crazy concept and need someone to bounce it off with, we're all ears. From new podcasts and comic strips to short film series and app ideas—if our frequencies sync, we'll be happy to partner with you on a joint venture and bring it to life.",
    image: "https://images.unsplash.com/photo-1765850259274-3d8fe17bfc55"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "AI Film Project 01",
    category: "AI Films",
    thumbnail: "https://images.unsplash.com/photo-1707340733209-d8adf5ad25e6",
    description: "An experimental AI-generated narrative exploring human connection in digital spaces."
  },
  {
    id: 2,
    title: "Brand Campaign 01",
    category: "Ad Films",
    thumbnail: "https://images.unsplash.com/photo-1661124280301-ca0e33ceb438",
    description: "Cinematic brand story crafted for a global audience."
  },
  {
    id: 3,
    title: "Short Film Series",
    category: "Shoot-Based Films",
    thumbnail: "https://images.unsplash.com/photo-1718073398740-9d3484bd6340",
    description: "A collection of narrative shorts blending traditional filmmaking with modern techniques."
  },
  {
    id: 4,
    title: "Social Campaign",
    category: "Social Content",
    thumbnail: "https://images.unsplash.com/photo-1765850259274-3d8fe17bfc55",
    description: "Viral social content that generated millions of impressions."
  },
  {
    id: 5,
    title: "AI Film Project 02",
    category: "AI Films",
    thumbnail: "https://images.unsplash.com/photo-1610845688109-23f080d7218b",
    description: "Pushing boundaries of AI storytelling with cutting-edge visual techniques."
  },
  {
    id: 6,
    title: "Digital Experience",
    category: "Websites",
    thumbnail: "https://images.unsplash.com/photo-1763470739662-b74dbc1e7ebe",
    description: "An immersive web experience that redefined brand interaction."
  }
];
